import BaseClass from "../util/BaseClass";
import ReferenceLayer from "../aiim/base/ReferenceLayer";

export default class Session extends BaseClass {

  cfgState = {};
  cfServiceDescription;
  networkServiceInfo;
  referenceLayer;
  selectedTravelModeID;
  startInConfiguratorMode;
  startupToast;

  constructor(props) {
    super(props);
    this.referenceLayer = new ReferenceLayer();
  }

  viewsReloading() {
    this.startupToast = null;
    this.referenceLayer = new ReferenceLayer();
  }

}
